import React, { ReactNode } from 'react';
import styled from 'styled-components';
import BaseButton from './BaseButton';
import { Colors } from '../../../../scss/common/style';

interface Props {
  size?: 'sm' | 'lg';
  onClick?: () => void;
  title?: string | JSX.Element | ReactNode;
  isSubmitting?: boolean;
  active?: boolean;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
  icon?: any;
}

export default function TableButton({
  onClick,
  title,
  isSubmitting = false,
  active = false,
  disabled = false,
  type,
  icon,
  size = undefined,
}: Props): JSX.Element {
  return (
    <ButtonWrapper>
      <StyledButton>
        <BaseButton
          type={type}
          title={title}
          onClick={onClick}
          isSubmitting={isSubmitting}
          disabled={disabled}
          active={active}
          icon={icon}
          size={size}
        />
      </StyledButton>
    </ButtonWrapper>
  );
}

const ButtonWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const StyledButton = styled.span`
  width: 100%;
  button {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: rgba(239, 125, 0, 0.09);
    color: ${Colors.newOrage};
    border-color: ${Colors.newOrage};
    border-radius: 5px; /* сделали угол почти острым, можно поставить 0 для полностью прямого */
    
    &:hover {
      color: ${Colors.darkRed};
      background-color: rgba(140, 41, 39, 0.09);
      border-color: ${Colors.darkRed};
    }
    &:active {
      color: ${Colors.darkBrown};
      background-color: rgba(100, 43, 38, 0.09);
      border-color: ${Colors.darkBrown};
    }
  }
`;
